<header>
  <app-banner></app-banner>
  <nav>
    <div class="nav-container" [class.is-burger-active]="isMenuActive">
      <div class="mobile-nav-bar">
        <app-logo></app-logo>

        @if (isSmallScreen) {
        <div class="mobile-nav-bar-right">
          <app-create-menu-button class="crea-menu-btn"></app-create-menu-button>
          <input
            id="menu-toggle"
            type="checkbox"
            [checked]="isMenuActive"
            (click)="toggleMenu()"
          />
          <label class="burger-button-container" for="menu-toggle">
            <div class="burger-button"></div>
          </label>
        </div>
        }
      </div>

      <!-- <div class="nav-center"> -->
      <ul class="menu">
        @for (link of menuLinks; track link; let i = $index) {
        <li>
          <a
            (click)="handleLinkClick(link.name, link.link)"
            [routerLink]="link.link"
            [class.active]="currentLink.includes(link.link)"
            [attr.role]="link.links ? 'button' : null"
            [attr.aria-expanded]="
              !isSmallScreen && link.name === 'Salute'
                ? isSaluteMenuOpened
                  ? 'true'
                  : 'false'
                : null
            "
            [attr.aria-controls]="
              !isSmallScreen && link.name === 'Salute' ? 'salute-panel' : null
            "
          >
            {{ link.name }}
            @if (link.links) {
            <img
              style="margin-left: 5px"
              src="/home-page/icons/nav/dropdown-arrow.svg"
              loading="lazy"
              alt="icona freccia dropdown"
              [style.transform]="
                !isSmallScreen && link.name === 'Salute' && isSaluteMenuOpened
                  ? 'rotate(90deg)'
                  : 'none'
              "
              [style.transition]="'transform .2s ease'"
            />
            }
          </a>
        </li>
        <div
          class="dropdown-content"
          [id]="link.name === 'Salute' ? 'salute-panel' : null"
          [class.is-active]="link.name === 'Salute' && isSaluteMenuOpened"
        >
          @for (link of link.links; track link) { @if (link.titolo !== 'BLOG') {
          <a [href]="link.route">{{ link.titolo }}</a>
          } @else {
          <a
            [href]="link.route"
            style="font-weight: 700; margin-bottom: 16px"
            >{{ link.titolo }}</a
          >
          } }
        </div>
        } @if(isSmallScreen){
        <ng-container *ngTemplateOutlet="callsToAction"></ng-container>
        }
      </ul>

      @if(!isSmallScreen){
      <ng-container *ngTemplateOutlet="callsToAction"></ng-container>
      }
    </div>
  </nav>
</header>

<ng-template #callsToAction>
  <div class="nav__right" [class.is-active]="isMenuActive">
    <div class="area-personale-container" (click)="goToLogin()">
      <img
        src="/home-page/icons/nav/area-personale.svg"
        loading="lazy"
        alt="icona avatar"
      />
      <p>Area Personale</p>
    </div>

    <app-create-menu-button class="crea-menu-btn"></app-create-menu-button>
  </div>
</ng-template>
